import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  LaunchOverrides,
  resolveCdsHook,
  resolveStandaloneMode,
} from '../models/dtr-types';

@Injectable({
  providedIn: 'root',
})
export class EnvService {
  private readonly translate = inject(TranslateService);
  private readonly httpBackend = inject(HttpBackend);
  private readonly http = new HttpClient(this.httpBackend);

  environment = environment;
  configError: Error | undefined;

  constructor() {
    try {
      this.loadConfig(environment);
    } catch (err) {
      this.configError = err as Error;
    }
  }

  async loadExternalConfig() {
    let config;
    try {
      config = await lastValueFrom(this.http.get('config/config.json'));
      console.log(this.translate.instant('Config.Loading'));
    } catch (err) {
      console.log(this.translate.instant('Config.NoExternal'));
      throw err;
    }
    try {
      this.loadConfig(config);
    } catch (err) {
      this.configError = err as Error;
    }
  }

  applyLaunchOverrides(overrides: LaunchOverrides): void {
    if (overrides.standalone === undefined && overrides.useHook === undefined) {
      return;
    }
    try {
      this.environment.standalone = resolveStandaloneMode(
        overrides.standalone ?? this.environment.standalone,
      );
      this.environment.useHook = resolveCdsHook(
        overrides.useHook ?? this.environment.useHook,
      );
      this.configError = undefined;
    } catch (err) {
      this.configError = err as Error;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private loadConfig(config: any) {
    for (const key in this.environment) {
      this.environment[key] = config[key];
    }
    if (
      this.environment.epaProxyBaseUrl &&
      !this.environment.epaProxyBaseUrl.endsWith('/')
    ) {
      this.environment.epaProxyBaseUrl += '/';
    }
    this.environment.standalone = resolveStandaloneMode(
      this.environment.standalone,
    );
    this.environment.useHook = resolveCdsHook(this.environment.useHook);
  }
}
